import { IsNotEmpty, IsUUID } from 'class-validator';

export class SetDefaultAttorneyDto {
  @IsUUID()
  @IsNotEmpty()
  attorneyId: string;
}
